var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('explore-study-sessions',{attrs:{"study-id":_vm.studyId}})}
var staticRenderFns = []

export { render, staticRenderFns }